import { Component } from "react";
import PropTypes from "prop-types";
import lodashGet from "lodash.get";
import AnalyticsContext from "../analytics-context";

class AdobePageBottom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      didMount: false,
      routeChanged: false,
      pathname: ""
    };
    // These attributes are for keeping track and making sure these events only fire once for each route change
    this.pageBottomIsFired = false; // this should only set to true once per app load
  }

  componentDidMount() {
    this.setState({ didMount: true });
  }

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      routeChanged: props.pathname !== state.pathname,
      pathname: props.pathname
    };
  }

  componentDidUpdate() {
    const { routeChanged, didMount } = this.state;

    if (routeChanged) {
      this.pageBottomIsFired = false;
    }
    const { dtmIsReady, ddlIsDirty } = this.context;
    const _satellite = lodashGet(global, "window._satellite");

    if (
      didMount &&
      dtmIsReady &&
      !ddlIsDirty &&
      _satellite &&
      !this.pageBottomIsFired
    ) {
      _satellite.pageBottom();
      this.pageBottomIsFired = true;
    }
  }

  render() {
    return null;
  }
}

AdobePageBottom.propTypes = {
  pathname: PropTypes.string,
  dtmIsReady: PropTypes.bool,
  ddlIsDirty: PropTypes.bool
};

AdobePageBottom.contextType = AnalyticsContext;

export { AdobePageBottom };
